import styled from 'styled-components';

export const InfoBar = styled.div(
    props => `
    border-radius: 1.2rem;
    background-color: #ffffff;
    padding: 1.4rem 1.1rem;
    margin-bottom: 1rem;
    margin: ${p => p.margin ? p.margin : ''};
    > p{
        font-family: 'Rubik';
        font-size: 1.6rem;
        line-height: 2.2rem;
        color: ${props.theme.colors.black.base}
    }
`);